import { render, staticRenderFns } from "./PageDynamicEditor.vue?vue&type=template&id=62b2969b&scoped=true&"
import script from "../../../js/views/dynamic-editor/PageDynamicEditor.js?vue&type=script&lang=js&"
export * from "../../../js/views/dynamic-editor/PageDynamicEditor.js?vue&type=script&lang=js&"
import style0 from "./PageDynamicEditor.vue?vue&type=style&index=0&id=62b2969b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b2969b",
  null
  
)

export default component.exports